import type { ApolloClient } from '@apollo/client'
import type { FilterDefinition } from '@factorialco/f0-react/dist/experimental'
import { CurrenciesFilterDataDocument } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { createAsyncFilterWithQuery } from './createAsyncFilterWithQuery'

export const createReimbursableCurrencyAsyncFilter = (
  apolloClient: ApolloClient<unknown>,
  companyId: number
): FilterDefinition =>
  createAsyncFilterWithQuery({
    label: i18n.t('expenses_v2.forms.fields.reimbursable_currency.label'),
    apolloClient,
    query: CurrenciesFilterDataDocument,
    variables: {},
    mapData: (data) => {
      const currencies = data?.apiCore?.currencies || []
      return [...currencies]
        .sort((cur1, cur2) => (cur1.priority > cur2.priority ? 1 : -1))
        .map((currency) => ({
          label: `${currency.isoCode} - ${currency.name}`,
          value: currency.isoCode,
        }))
    },
  })
